import React from "react";
import {IProjectItem} from "../../../types/IProjectItem";

export default function ProjectDuration({item}: { item: IProjectItem }) {

    return <React.Fragment>
        {item.content.month_start !== '' && <React.Fragment>{item.content.month_start}/</React.Fragment>}

        {item.content.year}

        {(item.content.ongoing || item.content.year_end) && ' - '}

        {item.content.ongoing && <React.Fragment>ongoing</React.Fragment>}

        {!item.content.ongoing && item.content.month_end !== '' && <React.Fragment>{item.content.month_end}/</React.Fragment>}
        {!item.content.ongoing && <React.Fragment>{item.content.year_end}</React.Fragment>}
    </React.Fragment>
}